import { render, staticRenderFns } from "./MerchantUser.vue?vue&type=template&id=62a891c4"
import script from "./MerchantUser.vue?vue&type=script&lang=js"
export * from "./MerchantUser.vue?vue&type=script&lang=js"
import style0 from "./MerchantUser.vue?vue&type=style&index=0&id=62a891c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports